import React, { PropTypes } from "react";
import { FormattedHTMLMessage, FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import { Field, formValueSelector, actions } from "redux-form";
import { EnumWrapper } from "../../../../../../utils/enums";
import { LANGUAGE_CODES } from "../../../../../../utils/enums/enums";
import { ArchiveButton } from "../../../../../common";
import { SelectInput, StyledCheckboxInput, TextInput } from "../../../../../common/form";
import roleTypes from "../enums/roleTypes";
import linkedInLogo from "../../../../../../assets/images/linkedin.png";
import { toast } from "react-toastify";
import { fieldCounter } from "../../../../../common/form/FieldCounter";
import { autoAdjustFieldHeight } from "../../../../../common/FieldHelper";
import { bindActionCreators } from "redux";

const MAX_NOTE_CHARACTER_LIMIT = 500;

class StrategicContactFields extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            emptyRole: false,
            remainingCharacterCount: MAX_NOTE_CHARACTER_LIMIT,
            noteFieldLengthError: false,
            noteFieldInitialized: false,
            noteLimitAlreadyReached: false,
            refreshTextField: 0,
        };
        this.handleRoleChange = this.handleRoleChange.bind(this);
        this.archiveFunction = this.archiveFunction.bind(this);
        this.handleNoteChange = this.handleNoteChange.bind(this);
        this.checkTextAreaLength = this.checkTextAreaLength.bind(this);
        this.initializeNoteField = this.initializeNoteField.bind(this);
        this.resetNoteField = this.resetNoteField.bind(this);
        this.renderLinkedinLogo = this.renderLinkedinLogo.bind(this);
        this.redirectToLinkedin = this.redirectToLinkedin.bind(this);
        this.isValidURL = this.isValidURL.bind(this);
        this.getLinkedInExtraErrorMessage = this.getLinkedInExtraErrorMessage.bind(this);
        this.trimOnChange = this.trimOnChange.bind(this);
        this.handleNoteBlur = this.handleNoteBlur.bind(this);
        this.handlePaste = this.handlePaste.bind(this);
    }

    componentWillMount() {
        const { initialValues } = this.props;
        if(initialValues && initialValues.note && typeof initialValues.note === "string" && initialValues.note.length === MAX_NOTE_CHARACTER_LIMIT) {
            this.setState({ noteLimitAlreadyReached: true });
        }
    }

    componentDidMount() {
        const { initialValues, changeFieldValue, keysToPost, emptyRole } = this.props;
        const initialValuesArray = Object.entries(initialValues);
        const contactIndex = initialValues.contactIndex;
        if (initialValuesArray.length) {
            // Manually initializes the form due to its potential multiple renderings.
            // To comply with React best practices, each field is assigned a distinct name.
            Object.entries(initialValues).forEach(([key, value]) => {
                if (keysToPost.includes(key)) {
                    changeFieldValue("strategicContactForm", `${key}-${contactIndex}`, value);
                }
            });
        }

        this.setState({
            emptyRole: emptyRole,
            remainingCharacterCount: initialValues.note
                ? Math.max(0, MAX_NOTE_CHARACTER_LIMIT - initialValues.note.length)
                : MAX_NOTE_CHARACTER_LIMIT,
        });
    }

    componentDidUpdate(prevProps) {
        const { clearValues, initialValues, submittingForm } = this.props;
        const { noteFieldInitialized } = this.state;

        this.state.emptyRole && clearValues(initialValues.contactIndex);

        if (this.props.note && this.props.note !== prevProps.note && !noteFieldInitialized) {
            /**
             * Since Redux-Forms sets field value after componentDidMount() is called, we can't call the initialize
             * function in componentDidMount. We need to detect field value initialization here.
             */
            this.setState({ noteFieldInitialized: true });
            this.initializeNoteField();
        }

        if (
            (initialValues.linkedin && initialValues.linkedin !== prevProps.initialValues.linkedin) ||
            (!initialValues.linkedin && !!prevProps.initialValues.linkedin)
        ) {
            /**
             * If linkedin link value changed and sent to API.
             * TextInput component doesn't re-render correctly after initialValues change (unless component is focused).
             * So we need to force a re-render.
             */
            this.setState((prevState) => {
                return {
                    ...prevState,
                    refreshTextField: prevState.refreshTextField + 1,
                };
            });
        }

        if(!submittingForm && prevProps.submittingForm === true) {
            this.setState({ noteFieldLengthError: false});
        }
    }

    initializeNoteField() {
        const { initialValues } = this.props;

        const nameFields = document.getElementsByName(`note-${initialValues.contactIndex}`);

        if (nameFields && initialValues.note && initialValues.note.length > 0) {
            const nameField = nameFields[0];
            nameField.style.height = nameField.scrollHeight + "px";
        }
    }

    handleNoteBlur(e) {
        if(e.relatedTarget && e.relatedTarget.className.includes("btn")) {
            return;
        }
        if(this.state.noteFieldLengthError === true) {
            this.setState({ noteFieldLengthError: false });
        }
    }

    resetNoteField() {
        const { initialValues } = this.props;
        const nameFields = document.getElementsByName(`note-${initialValues.contactIndex}`);

        if (nameFields) {
            const nameField = nameFields[0];
            nameField.style.height = "auto";
            this.setState({ remainingCharacterCount: MAX_NOTE_CHARACTER_LIMIT, noteFieldLengthError: false });
        }
    }

    handleNoteChange(e) {
        const text = e.target.value;
        autoAdjustFieldHeight(e, text, this.props.initialValues.contactIndex);
        this.setState({
            remainingCharacterCount: text
                ? Math.max(0, MAX_NOTE_CHARACTER_LIMIT - text.length)
                : MAX_NOTE_CHARACTER_LIMIT,
        });
    }
    checkTextAreaLength(e) {
        const { noteLimitAlreadyReached } = this.state;
        const text = e.target.value;
        const limitReached = text.length === MAX_NOTE_CHARACTER_LIMIT;
        if (limitReached && !noteLimitAlreadyReached) {
            this.setState({ noteLimitAlreadyReached: true });
            return;
        }

        if (limitReached && noteLimitAlreadyReached) {
            this.setState({ noteFieldLengthError: true });
        } else {
            this.setState({ noteFieldLengthError: false, noteLimitAlreadyReached: false });
        }
    }

    handlePaste(e) {
        /**
         * Check if user clipboard text exceeds limit, if true, we set error
         */
        const clipboardData = e.clipboardData.getData("text");
        let totalLength = clipboardData.length;

        if(this.props.note && this.props.note.length > 0) {
            totalLength += this.props.note.length;
        }

        if(totalLength > MAX_NOTE_CHARACTER_LIMIT) {
            this.setState({ noteFieldLengthError: true, noteLimitAlreadyReached: true });
            return;
        }
        this.checkTextAreaLength(e);    
    }

    archiveFunction(clientContactId, contactIndex) {
        this.setState({
            emptyRole: true,
        });
        this.props.archiveClientContact(clientContactId, contactIndex);
        this.resetNoteField();
    }
    handleRoleChange(event) {
        const value = event[0];
        const emptyRole = !value || value.trim() === "";

        this.setState({
            emptyRole: emptyRole,
        });
    }

	isValidURL(url) {
        try{
            const { linkedinRegex } = this.props;
            return linkedinRegex.test(url);
        }
        catch(e) {
            return false;
        }
	}

	redirectToLinkedin(e) {
		e.preventDefault();
		const { linkedin } = this.props.initialValues;
		const isValidURL = this.isValidURL(linkedin);
		if(!isValidURL) {
		toast(
			<FormattedHTMLMessage
			id="clientContacts.form.strategicContact.linkedInWebsiteError"
			/>,
			{
			type: toast.TYPE.ERROR,
			autoClose: false,
			}
		);
			return;
		}

		window.open(linkedin, '_blank').focus();
	}

    renderLinkedinLogo() {
        const { allowLinkedinLink } = this.props.initialValues;
        return allowLinkedinLink ? (
            <button className="linkedin-btn" onClick={this.redirectToLinkedin}>
                <img width="16" src={linkedInLogo} />
            </button>
        ) : null;
    }
    
    getLinkedInExtraErrorMessage() {
        return <FormattedHTMLMessage id="clientContacts.form.strategicContact.linkedInWebsiteRegexList"/>;
    }

    trimOnChange(e) {
        const { changeFieldValue } = this.props;

        const text = e.target.value;
        const trimmedValue = text ? text.trim() : '';
        this.props.formActions.touch("strategicContactForm", e.target.name);
        this.props.formActions.focus("strategicContactForm", e.target.name);
        changeFieldValue("strategicContactForm", e.target.name, trimmedValue);
        this.props.formActions.blur("strategicContactForm", e.target.name);
    }

    render() {
        const { disabled, initialValues, index, blockDeleteRole, role } = this.props;
        const disableField = disabled || this.state.emptyRole;
        const { formatMessage } = this.context.intl;
        const { noteFieldLengthError } = this.state;

        const notePlaceholder = formatMessage({ id: "clientContacts.form.strategicContact.notePlaceholder" });

        return (
            <div key={index}>
                <h4>
                    <FormattedMessage
                        id="clientContacts.form.strategicContact.contact"
                        values={{ contactIndex: initialValues.contactIndex }}
                    />
                </h4>
                <Field
                    id="role"
                    name={`role-${initialValues.contactIndex}`}
                    type="text"
                    component={SelectInput}
                    options={roleTypes}
                    sortOptions={false}
                    required={true}
                    searchable={blockDeleteRole}
                    label={<FormattedMessage id="clientContacts.form.strategicContact.role" />}
                    disabled={disabled}
                    onChange={this.handleRoleChange}
                />
                <Field
                    id="title"
                    name={`title-${initialValues.contactIndex}`}
                    type="text"
                    component={TextInput}
                    required={role === "OTHER"}
                    label={<FormattedMessage id="clientContacts.form.strategicContact.contactTitle" />}
                    disabled={disableField}
                    customOnBlurFunc={this.trimOnChange}
                />
                <Field
                    id="firstName"
                    name={`firstName-${initialValues.contactIndex}`}
                    type="text"
                    component={TextInput}
                    required={!this.state.emptyRole}
                    label={<FormattedMessage id="clientContacts.form.strategicContact.firstName" />}
                    disabled={disableField}
                    customOnBlurFunc={this.trimOnChange}
                />
                <Field
                    id="lastName"
                    name={`lastName-${initialValues.contactIndex}`}
                    required={!this.state.emptyRole}
                    type="text"
                    component={TextInput}
                    label={<FormattedMessage id="clientContacts.form.strategicContact.lastName" />}
                    disabled={disableField}
                    customOnBlurFunc={this.trimOnChange}
                />
                <Field
                    id="phoneNumber"
                    name={`phoneNumber-${initialValues.contactIndex}`}
                    type="text"
                    component={TextInput}
                    label={<FormattedMessage id="clientContacts.form.strategicContact.phoneNumber" />}
                    disabled={disableField}
                />

                <Field
                    id="emailAddress"
                    name={`emailAddress-${initialValues.contactIndex}`}
                    type="text"
                    component={TextInput}
                    label={<FormattedMessage id="clientContacts.form.strategicContact.emailAddress" />}
                    disabled={disableField}
                />

                <EnumWrapper enum={LANGUAGE_CODES} format="inputs" prop="options">
                    <Field
                        id="languageCode"
                        name={`languageCode-${initialValues.contactIndex}`}
                        component={SelectInput}
                        disabled={disableField}
                        addBlankOption={true}
                        label={<FormattedMessage id="clientContacts.form.strategicContact.language" />}
                    />
                </EnumWrapper>
                <Field
                    id="linkedin"
                    name={`linkedin-${initialValues.contactIndex}`}
                    type="text"
                    component={TextInput}
                    formattedMessageErrorValues={{br: <br/>}}
                    customOnBlurFunc={this.trimOnChange}
                    getExtraFormattedError={this.getLinkedInExtraErrorMessage}
                    refreshTextField={this.state.refreshTextField}
                    displayLogo={this.renderLinkedinLogo}
                    label={<FormattedMessage id="clientContacts.form.strategicContact.linkedin" />}
                    disabled={disableField}
                />
                <div id={`hidden-div-${initialValues.contactIndex}`}/>
                <Field
                    id="note"
                    name={`note-${initialValues.contactIndex}`}
                    type="textarea"
                    componentClass="textarea"
                    className="expandable-text-area"
                    placeholder={notePlaceholder}
                    maxLength={MAX_NOTE_CHARACTER_LIMIT}
                    onChange={this.handleNoteChange}
                    onBlur={this.handleNoteBlur}
                    handleOnPaste={this.handlePaste}
                    handleKeyPressCB={this.checkTextAreaLength}
                    handleOnInput={this.checkTextAreaLength}
                    component={TextInput}
                    label={<FormattedMessage id="clientContacts.form.strategicContact.comment" />}
                    disabled={disableField}
                />
                {noteFieldLengthError && (
                    <span className="error-message danger note-error">
                        <FormattedMessage id="clientContacts.form.strategicContact.noteLimitError" />
                    </span>
                )}
                {fieldCounter(this.state.remainingCharacterCount)}
                <div className="strategic-contact-buttons">
                    <Field
                        groupClassName="wrapping"
                        id={`isMainStrategic-${initialValues.contactIndex}`}
                        name={`isMainStrategic-${initialValues.contactIndex}`}
                        type="checkbox"
                        disabled={disableField}
                        component={StyledCheckboxInput}
                        checkbox={{ value: true }}
                        label={<FormattedMessage id="clientContacts.form.strategicContact.primaryStrategicContact" />}
                        normalize={(value) => !!value}
                    />
                    <ArchiveButton
                        isArchived={false}
                        label={<FormattedMessage id="common.delete" />}
                        title={"archiveButton.modal.title.delete"}
                        archivedName={initialValues.contactIndex.toString()}
                        confirmationMessage="clientContacts.archiveConfirmationMessage"
                        disabled={disableField}
                        archiveFunction={() => {
                            this.archiveFunction(initialValues.clientContactId, initialValues.contactIndex.toString());
                        }}
                    />
                </div>
            </div>
        );
    }
}

StrategicContactFields.contextTypes = {
    intl: intlShape,
};

StrategicContactFields.propTypes = {
    client: PropTypes.object.isRequired,
    initialValues: PropTypes.object,
    submittingForm: PropTypes.bool,
    disabled: PropTypes.bool,
    blockDeleteRole: PropTypes.bool,
    emptyRole: PropTypes.bool,
    setFormValue: PropTypes.func,
    changeFieldValue: PropTypes.func.isRequired,
    archiveClientContact: PropTypes.func.isRequired,
    clearValues: PropTypes.func.isRequired,
    keysToPost: PropTypes.array.isRequired,
    index: PropTypes.number,
    linkedinRegex: PropTypes.oneOfType([PropTypes.string, PropTypes.regexp]),
    note: PropTypes.string,
    formActions: PropTypes.object,
    role: PropTypes.string
};

StrategicContactFields.childContextTypes = {
    scrollTop: PropTypes.func,
  };



function mapStateToProps(state, ownProps) {
    const selector = formValueSelector("strategicContactForm");
    const { initialValues } = ownProps;

    return {
        role: selector(state, `role-${initialValues.contactIndex}`),
        note: selector(state, `note-${ownProps.initialValues.contactIndex}`)
    };
}

function mapDispatchToProps(dispatch) {
    return {
         formActions: bindActionCreators(actions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
    withRef: true,
})(StrategicContactFields);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/contacts/strategic-contacts/StrategicContactFields.js